// Pure SVG marks ported from the comps. Server-safe (no client hooks).

export function Logo({ className = 'logo-mark' }: { className?: string }) {
  return (
    <svg viewBox="0 0 100 100" className={className} aria-label="2Factor">
      <g transform="rotate(270,50,50)">
        <polygon points="10,50 50,10 90,50 50,90" fill="none" stroke="currentColor" strokeWidth="5" />
        <line x1="50" y1="50" x2="50" y2="90" stroke="currentColor" strokeWidth="5" />
        <line x1="10" y1="50" x2="90" y2="50" stroke="currentColor" strokeWidth="5" />
      </g>
    </svg>
  );
}

export function Wordmark() {
  return <span className="wm">2<span style={{ margin: '0 1px' }}>&middot;</span>factor</span>;
}

export function XIcon({ size = 14 }: { size?: number }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="currentColor">
      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
    </svg>
  );
}
export function TelegramIcon({ size = 15 }: { size?: number }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="currentColor">
      <path d="M21.5 4.3 2.5 11.7c-1.3.5-1.3 1.3-.2 1.6l4.9 1.5 1.9 5.7c.2.6.4.9.9.9.4 0 .6-.2.9-.5l2.3-2.2 4.7 3.5c.9.5 1.5.2 1.7-.8l3.1-14.6c.3-1.3-.5-1.9-1.3-1.5zM8.8 15.3l-.7 3.3-1.5-4.7L18.5 7c.4-.2.7 0 .4.3z" />
    </svg>
  );
}
export function WebIcon({ size = 14 }: { size?: number }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth="1.6">
      <circle cx="12" cy="12" r="9" />
      <path d="M12 3c2 3 3 6 3 9s-1 6-3 9c-2-3-3-6-3-9s1-6 3-9z" />
      <line x1="3" y1="12" x2="21" y2="12" />
    </svg>
  );
}
export function ChevronIcon({ className = '' }: { className?: string }) {
  return (
    <svg viewBox="0 0 21 11.2" className={className} fill="none" aria-hidden>
      <path d="M0.5 0.5L10.5 10.5L20.5 0.5" stroke="currentColor" strokeLinecap="round" />
    </svg>
  );
}
export function ShareNodesIcon({ size = 16 }: { size?: number }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth="1.6" aria-hidden>
      <circle cx="18" cy="5" r="3" /><circle cx="6" cy="12" r="3" /><circle cx="18" cy="19" r="3" />
      <line x1="8.6" y1="10.5" x2="15.4" y2="6.5" /><line x1="8.6" y1="13.5" x2="15.4" y2="17.5" />
    </svg>
  );
}
